<template>
  <v-layout class="vuetify-btn-toggle" row wrap>
    <v-flex xs12>
      <v-btn-toggle
        v-model="value"
        v-for="(item, i) in items" :key="i"
      >
        <v-btn flat :value="item.value">
          {{ item.text }}
        </v-btn>
      </v-btn-toggle>
    </v-flex>
  </v-layout>
</template>

<script>

'use strict'

export default {

  name: 'VuetifyBtnToggle',

  created () {
    this.value = this.selected
  },

  data: () => ({
    value: null
  }),

  props:
  {
    items: {
      type: Array,
      default: null,
      required: true
    },
    selected: {
      default: 0
    }
  },

  watch: {
    selected (val) {
      this.value = this.selected
    },
    value (val) {
      this.$emit('on-change', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vuetify-btn-toggle.vue